export { default } from "./FaqSchema";
